function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.40289 6.81761L1.10917 4.59097C0.85359 4.34285 0.447274 4.34285 0.191689 4.59097C-0.0638963 4.83908 -0.0638963 5.23351 0.191689 5.48162L2.93759 8.14723C3.19318 8.39534 3.60605 8.39534 3.86163 8.14723L10.8083 1.41005C11.0639 1.16194 11.0639 0.767508 10.8083 0.519396C10.5527 0.271285 10.1464 0.271285 9.89083 0.519396L3.40289 6.81761Z",
  fill: "currentColor"
});
function SvgDoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneWhite);
export default __webpack_public_path__ + "static/media/done-white.40fc3c73.svg";
export { ForwardRef as ReactComponent };